// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".copy-to-clipboard-button-container__tC7VouYp .copy-to-clipboard-button__lY_btfob{min-width:40px;text-align:center}.copy-to-clipboard-select__np6xw3gN{align-self:center;display:flex;height:34px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"copyToClipboardButtonContainer": "copy-to-clipboard-button-container__tC7VouYp",
	"copyToClipboardButton": "copy-to-clipboard-button__lY_btfob",
	"copyToClipboardSelect": "copy-to-clipboard-select__np6xw3gN"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
